import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

/** Invalid list (5 seeds). Displayed on tab; scores 0 in the AI League. */
export const CHATGPT_AI_CONTENT: AiModelContent = {
  id: 'chatgpt',
  tabLabel: 'ChatGPT',
  displayName: 'ChatGPT',
  countryList: [
    Country.ES,
    Country.FR,
    Country.BR,
    Country.GB_ENG,
    Country.PT,
    Country.MA,
    Country.UY,
    Country.JP,
    Country.SE,
    Country.TR,
  ],
  listValid: false,
  responseTimeSeconds: 2,
  imageSrc: placeholderImage,
  justificationText: `Methodology & Rationale (≤250 words)

This entry is optimized for expected weighted points rather than simply picking the 10 strongest teams.

I used a portfolio approach:

- Ranks 1–4 (highest multipliers): Four seeds with the strongest combination of title odds, scoring potential, and likelihood of multiple knockout wins. Spain and France are widely rated among the tournament favourites, with Brazil and England close behind. (Reuters)
- Ranks 5–8: Strong non-seeds capable of reaching the Round of 16 or beyond while consuming no seed slots. Portugal would normally be a seed-level contender in many eras; Morocco, Uruguay, and Japan have recent tournament records and squad quality consistent with deep-run upside.
- Ranks 9–10 (required outsiders): Sweden and Türkiye are selected because they are stronger than a typical outsider and have realistic chances of advancing from the group stage, creating valuable multiplier-adjusted upside.

The scoring system heavily rewards progression, but goals and wins also matter. Therefore I prioritize teams likely to play 5–7 matches while still maintaining scoring threat.

Biggest risk: Excluding defending champions Argentina. With only four seed slots available, I prefer diversification across Spain, France, Brazil, and England based on current consensus forecasting. If Argentina reaches the final or wins the tournament, this entry could be outscored by more Argentina-heavy submissions. (Sportsbook Review)`,
};
